module.exports = __webpack_public_path__ + "img/Bodice-Front-B4-Jd.40a7336b.png";